import type { useNavigate } from '@tanstack/react-router';

import { AI_DATA_POLICY_SECTION_ID } from '@shared/ai-data-policy/types';

type Navigate = ReturnType<typeof useNavigate>;

export function goToDataPolicySettings(navigate: Navigate): void {
  document.getElementById(AI_DATA_POLICY_SECTION_ID)?.scrollIntoView({ block: 'start' });
  void navigate({ to: '/settings/company', search: { section: AI_DATA_POLICY_SECTION_ID } });
}

export const DATA_POLICY_HELP_URL = 'https://investbanq.com/help/ai-cio-investor-data';
